import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	service: {
		id: 'compass-common.common.component-types-metadata.service',
		defaultMessage: 'Service',
		description: 'The label for a software service.',
	},
	library: {
		id: 'compass-common.common.component-types-metadata.library',
		defaultMessage: 'Library',
		description: 'A software package that can be reused by other people',
	},
	application: {
		id: 'compass-common.common.component-types-metadata.application',
		defaultMessage: 'Application',
		description: 'A standalone piece of software that is directly consumable by an end-user.',
	},
	other: {
		id: 'compass-common.common.component-types-metadata.other',
		defaultMessage: 'Other',
		description:
			'A component of a type not covered by the more specific types of Service, Application, and Library',
	},
	capability: {
		id: 'compass-common.common.component-types-metadata.capability',
		defaultMessage: 'Capability',
		description:
			'A type (category) of component in Compass representing a Capability of a software service',
	},
	cloudResource: {
		id: 'compass-common.common.component-types-metadata.cloud-resource',
		defaultMessage: 'Cloud resource',
		description: 'A type (category) of component in Compass representing a Cloud resource',
	},
	dataPipeline: {
		id: 'compass-common.common.component-types-metadata.data-pipeline',
		defaultMessage: 'Data pipeline',
		description: 'A type (category) of component in Compass representing a Data pipeline',
	},
	machineLearningModel: {
		id: 'compass-common.common.component-types-metadata.machine-learning-model',
		defaultMessage: 'Machine learning model',
		description: 'A type (category) of component in Compass representing a Machine learning model',
	},
	template: {
		id: 'compass-common.common.component-types-metadata.template',
		defaultMessage: 'Template',
		description: 'A type (category) of component in Compass representing a Template',
	},
	uiElement: {
		id: 'compass-common.common.component-types-metadata.ui-element',
		defaultMessage: 'UI element',
		description:
			'A type (category) of component in Compass representing a UI (User Interface) element',
	},
	website: {
		id: 'compass-common.common.component-types-metadata.website',
		defaultMessage: 'Website',
		description: 'A type (category) of component in Compass representing a Website',
	},
	dataset: {
		id: 'compass-common.common.component-types-metadata.dataset',
		defaultMessage: 'Dataset',
		description: 'A type (category) of component in Compass representing a Dataset',
	},
	dataProduct: {
		id: 'compass-common.common.component-types-metadata.data-product',
		defaultMessage: 'Data product',
		description: 'A type (category) of component in Compass representing a Data product',
	},
	dashboard: {
		id: 'compass-common.common.component-types-metadata.dashboard',
		defaultMessage: 'Dashboard',
		description: 'A type (category) of component in Compass representing a Dashboard',
	},
});
